import React from 'react';
import LoadingText from '../atoms/LoadingText';
import LottieAnim from '../atoms/LottieAnim';
const Loader = ({ messages, show }) => {
    return (React.createElement("div", { className: `th-c-loader ${show ? 'show' : ''}` },
        React.createElement("span", { className: "th-c-loader__wrapper" },
            React.createElement(LottieAnim, null)),
        React.createElement(LoadingText, { text: messages, customClass: "th-c-loader__text" })));
};
export default Loader;
